// Module
var code = `<template>
  <require from="./portfolio-overview-widget.scss"></require>

  <div class="portfolio-overview-widget portfolio-overview-widget-\${id}">
    <style if.bind="config.hidePaging">
      .ag-paging-panel {
        display: none !important;
      }
    </style>

    <!-- beautify ignore:start -->
    <style>
      .portfolio-overview-widget-\${id} .ag-header,
      .portfolio-overview-widget-\${id} .ag-cell {
        font-size: \${fontSize}px !important;
      }

      .portfolio-overview-widget-\${id} .ag-cell {
        line-height: \${rowHeight}px !important;
      }
    </style>
    <!-- beautify ignore:end -->

    <ag-grid-aurelia if.bind="!error" grid-options.bind="gridOptions" class="\${isInDashboard && themeService.darkTheme ? 'ag-theme-balham-dark' : 'ag-theme-balham ag-theme-balham-report'}">

      <ag-grid-column header-name="Name" field="name" editable="false"></ag-grid-column>

      <ag-grid-column header-name="Report name" field="reportName" editable="false" hide-col="true"></ag-grid-column>

      <ag-grid-column header-name="ISIN" field="isin" editable="false"></ag-grid-column>

      <ag-grid-column header-name="Term" field="longTerm" hide-col.bind="true" width.bind="80" editable="false" cell-data-type.bind="false" filter="agSetColumnFilter" value-formatter.bind="termValueFormatter"></ag-grid-column>

      <ag-grid-column header-name="Type" field="type" editable="false" row-group.bind="config.groupBy === PortfolioOverviewGroupBy.Type"></ag-grid-column>

      <ag-grid-column header-name="Category" field="category" editable="false" hide-col="true" row-group.bind="config.groupBy === PortfolioOverviewGroupBy.Category"></ag-grid-column>

      <ag-grid-column header-name="Sell Price" field="sellPrice" type="rightAligned" editable="false" hide-col="true" value-formatter.bind="moneyFormatter"></ag-grid-column>

      <ag-grid-column header-name="Sell Price Ccy" field="sellPriceCcy" editable="false" hide-col="true"></ag-grid-column>

      <ag-grid-column header-name="Cost Price ea" field="costPriceClosingBalance" type="rightAligned" editable="false" hide-col="true" value-formatter.bind="costPriceEaFormatter"></ag-grid-column>

      <ag-grid-column header-name="Quantity" field="quantityClosingBalance" editable="false" editable="false" type="rightAligned" value-formatter.bind="quantityFormatter"></ag-grid-column>

      <ag-grid-column header-name="Value" field="estimatedValueClosingBalance" editable="false" editable="false" type="rightAligned" agg-func="sum" value-formatter.bind="moneyFormatter" sort="desc"></ag-grid-column>

      <ag-grid-column header-name="Cost Price" field="costPriceClosingBalance" type="rightAligned" editable="false" agg-func="sum" value-formatter.bind="moneyFormatter"></ag-grid-column>

      <ag-grid-column header-name="Unreal. UB" field="unrealizedProfitLossClosingBalance" type="rightAligned" editable="false" agg-func="sum" value-formatter.bind="moneyFormatter"></ag-grid-column>

      <ag-grid-column header-name="Unrealized %" field="unrealisedPercent" type="rightAligned" editable="false" agg-func="sum" value-formatter.bind="moneyFormatter" hide-col="true"></ag-grid-column>

      <ag-grid-column header-name="Unreal. LY" field="unrealizedProfitLossEndOfLastYear" type="rightAligned" hide-col="true" type="rightAligned" editable="false" agg-func="sum"></ag-grid-column>

      <ag-grid-column header-name="Unreal. YTD" field="unrealizedProfitLossChangeYearToDate" type="rightAligned" hide-col="true" editable="false" agg-func="sum" value-formatter.bind="moneyFormatter"></ag-grid-column>

      <ag-grid-column header-name="+ Real. YTD" field="realizedProfitLossChangeYearToDate" type="rightAligned" hide-col="true" editable="false" agg-func="sum" value-formatter.bind="moneyFormatter"></ag-grid-column>

      <ag-grid-column header-name="+ Divid. YTD" field="dividendChangeYearToDate" type="rightAligned" editable="false" hide-col="true" agg-func="sum" value-formatter.bind="moneyFormatter"></ag-grid-column>

      <ag-grid-column header-name="+ Int. YTD" field="interestChangeYearToDate" type="rightAligned" editable="false" hide-col="true" agg-func="sum" value-formatter.bind="moneyFormatter"></ag-grid-column>

      <ag-grid-column header-name="= P&L YTD" field="profitLossChangeYearToDate" type="rightAligned" editable="false" agg-func="sum" value-formatter.bind="moneyFormatter"></ag-grid-column>

      <ag-loading-overlay-template>
        <mdc-circular-progress></mdc-circular-progress>
      </ag-loading-overlay-template>
    </ag-grid-aurelia>

    <message if.bind="error" class="portfolio-overview-widget__error" icon="error" colour="mdc-theme--error">
      \${error.message}
    </message>
  </div>
</template>
`;
// Exports
export default code;